export default ({ currencyCode, products = [] } = {}) => {
  return {
    event: 'productImpression',
    ecommerce: {
      actionField: {
        list: 'Baggage MYB',
      },
      currencyCode: currencyCode,
      impressions: products,
    },
  };
};
